import React, { useState } from 'react';
import { Delete, Edit } from '@mui/icons-material';
// @mui
import {
  Stack,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import ModalDialog from 'src/components/Global/ModalDialog';

const TypeTile = ({ onEdit, onDelete, isDisabled, type }) => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <ListItem
        secondaryAction={
          <Stack direction="row">
            <IconButton
              edge="end"
              aria-label="delete"
              size="small"
              disabled={isDisabled}
              onClick={() => onEdit(type.id)}
            >
              <Edit size="small" />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="delete"
              size="small"
              disabled={isDisabled}
              onClick={handleOpenModal}
            >
              <Delete size="small" />
            </IconButton>
          </Stack>
        }
      >
        <ListItemText
          primary={type.type}
          sx={{ color: isDisabled ? '#d3d3d3' : undefined }}
        />
        <ModalDialog
          title="Delete type?"
          subTitle={`Are you sure do you want to delete this type? `}
          hardWarning={`This will affect all associated blogs to be not visible on the website.`}
          item={type.type}
          open={openModal}
          handleClose={handleCloseModal}
          handleClickOk={() => {
            handleCloseModal();
            onDelete(type.id);
          }}
        />
      </ListItem>

      <Divider />
    </>
  );
};

export default TypeTile;
